// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12kaO","inner":"Footer_inner__knHIL","nextIcon":"Footer_nextIcon__egWAK","innerLeft":"Footer_innerLeft__3Jlui"};